import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildLogPile: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const tiers = [
        { length: 5, y: 0 },
        { length: 5, y: 1 },
        { length: 4, y: 2 },
        { length: 3, y: 3 },
        { length: 2, y: 4 },
        { length: 1, y: 5 },
    ];

    for (const tier of tiers) {
        brush.lineX(0, tier.length - 1, tier.y, 0, BLOCK.Log);
    }
    brush.lineX(0, 3, 0, 2, BLOCK.Log);
    brush.lineX(0, 3, 1, 2, BLOCK.Log);
    brush.lineX(0, 1, 2, 2, BLOCK.Log);
};
